// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"240b22dc","787":"b2f9665e"}[chunkId] + ".chunk.js";
};